import { ApplicationConfig } from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import {provideRouter, withInMemoryScrolling, withRouterConfig, withViewTransitions} from '@angular/router';
import {routes} from './app.routes';
import { getApp, initializeApp, provideFirebaseApp } from '@angular/fire/app';
import {environment} from '../environments/environment';
import {initializeFirestore, provideFirestore} from '@angular/fire/firestore';
import {getAuth, provideAuth} from '@angular/fire/auth';
import {provideHttpClient} from '@angular/common/http';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes,
      withRouterConfig({ paramsInheritanceStrategy: 'always' }),
      withViewTransitions(),
      withInMemoryScrolling({
        scrollPositionRestoration: 'enabled',
      }),
    ),
    provideHttpClient(),
    provideFirebaseApp(() => {
      return initializeApp(environment.firebase);
    }),
    provideFirestore(() => initializeFirestore(getApp(), { experimentalAutoDetectLongPolling: true })),
    provideAuth(() => getAuth()),
    provideAnimationsAsync(),
  ]
};
